import React, { useState, useEffect } from "react";
import { FixedSizeList } from "react-window";
import {
  Grid,
  FormControlLabel,
  Checkbox,
  Button,
  IconButton,
  TextField,
  ListItemText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

import { DnDCard } from "app/common/components/DnD/Card";
import ColorsListDropDown from "app/common/components/input/ColorsListDropDown";
import ColorsSet from "app/common/utils/ColorsSet";
import ApiClient from "utils/ApiClient";

const useStyles = makeStyles((theme) => ({
  grid: {
    marginTop: 10,
    fontWeight: 500,
  },
}));

const itemHeight = 40;
function DropDownColumnConfig({ store, values, handleChange, setFieldValue }) {
  const classes = useStyles();
  if (typeof values.options.allow_free_text == "undefined") {
    values.options["allow_free_text"] = true;
  }

  const name = "default_email";
  const {
    options: {
      options = [],
      colors = [],
      default_value,
      allow_free_text,
      column_type,
    },
  } = values;
  const [editingOptionIndex, setEditingOptionIndex] = useState(null);

  const addTextOptionsToConfig = async () => {
    const resp = await ApiClient.List.getColumnUniqueData({
      column_id: "column_" + store.column.column_id,
      list_id: store.column.list_id,
      limit: 1000,
    });
    let textOptions = [];
    let textColors = [];
    let colorIndex = 0;
    for (let i = 0; i < resp.data.length; i++) {
      if (resp.data[i]["column_" + store.column.column_id] !== "") {
        textOptions.push(resp.data[i]["column_" + store.column.column_id]);
        textColors.push(ColorsSet[colorIndex]);
        colorIndex += 1;
      }
    }
    if (textOptions.length > 0) {
      setFieldValue("options.options", textOptions);
      setFieldValue("options.colors", textColors);
    }
  };

  const handleOutSideClick = () => {
    setEditingOptionIndex();
  };

  useEffect(() => {
    window.addEventListener("mousedown", handleOutSideClick);
    if (options.length < 1) {
      handleAddNewOption();
    }
    if (
      store?.column?.column_type_id &&
      store?.column?.column_type_id === "1" &&
      options.length < 1
    ) {
      addTextOptionsToConfig();
    }
    return () => {
      window.removeEventListener("mousedown", handleOutSideClick);
    };
  }, [options]);

  const handleEdit = (val, i) => {
    options[i] = val;
    setFieldValue("options.options", options);
  };

  const handleColorChange = (val, i) => {
    colors[i] = val;
    setFieldValue("options.colors", colors);
  };

  const handleDelete = (i) => {
    options.splice(i, 1);
    colors.splice(i, 1);
    setFieldValue("options.options", options);
    setFieldValue("options.colors", colors);
  };

  const nextColorIndex = () => {
    let lastColorIndex = -1;
    if (values.options?.colors?.length > 0) {
      let lastUsedColor =
        values.options.colors[values.options.colors.length - 1];
      lastColorIndex = ColorsSet.findIndex((color) => {
        return color == lastUsedColor;
      });
    }
    return lastColorIndex + 1;
  };

  const handleAddNewOption = () => {
    setFieldValue("options.options", [...options, ""]);
    setFieldValue("options.colors", [
      ...colors,
      ColorsSet[nextColorIndex() % ColorsSet.length 
        // values.options?.colors?.length
        //   ? values.options?.colors?.length % ColorsSet.length
        //   : 0
      ],
    ]);
    setEditingOptionIndex(options.length);
  };

  const handleEnterKeyPress = (index) => {
    if (index + 1 == options.length) {
      handleAddNewOption();
      return;
    }
    setEditingOptionIndex(index + 1);
  };

  const moveOption = (dragIndex, hoverIndex) => {
    const newOptions = [...options];
    const newColors = [...colors];

    newOptions.splice(hoverIndex, 0, ...newOptions.splice(dragIndex, 1));
    newColors.splice(hoverIndex, 0, ...newColors.splice(dragIndex, 1));

    setFieldValue("options.options", newOptions);
    setFieldValue("options.colors", newColors);
  };

  return (
    <>
      <Grid item>
        <FixedSizeList
          itemData={{
            options,
            colors,
            onEdit: handleEdit,
            onStartEdit: setEditingOptionIndex,
            editingIndex: editingOptionIndex,
            onColorChange: handleColorChange,
            onDelete: handleDelete,
            onStopEdit: setEditingOptionIndex,
            onEnterKeyPress: handleEnterKeyPress,
            moveOption: moveOption,
          }}
          height={Math.min(200, itemHeight * options.length)}
          width={300}
          itemSize={itemHeight}
          itemCount={options.length}
        >
          {OptionRowDnD}
        </FixedSizeList>
      </Grid>
      <Grid item xs={12} className={classes.grid}>
        <Button size="small" onClick={handleAddNewOption} component="a">
          +add option
        </Button>
      </Grid>

      {/* {options.findIndex((x) => x.length > 0) !== -1 && ( */}
      {
        <StyledFormControl>
          <InputLabel id="default_value_label">Default Value</InputLabel>
          <Select
            labelId="default_value_label"
            id="default_value"
            name="options.default_value"
            value={default_value}
            onChange={handleChange}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {options.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </StyledFormControl>
      }
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              color="primary"
              name={`options.allow_free_text`}
              checked={values.options.allow_free_text}
              onChange={handleChange}
            />
          }
          label={"Allow free text?"}
        />
      </Grid>
    </>
  );
}

function OptionRowDnD(props) {
  const {
    index,
    style,
    data: { moveOption, options },
  } = props;

  return (
    <DnDCard
      index={index}
      key={index}
      moveCard={moveOption}
      id={options[index]}
      style={style}
      opacityOnDrag={1}
    >
      <OptionRow {...props} />
    </DnDCard>
  );
}

function OptionRow(props) {
  const {
    index,
    data: {
      options,
      colors,
      onStartEdit,
      onEdit,
      onDelete,
      editingIndex,
      onStopEdit,
      onColorChange,
      onEnterKeyPress,
    },
  } = props;
  let isEditing = editingIndex === index;

  return (
    <StyledOptionRow key={index}>
      <ColorsListDropDown
        colors={ColorsSet}
        onChange={(col) => onColorChange(col, index)}
        value={colors[index]}
      />
      <ListItemText
        style={{ height: "100%", paddingLeft: 5, minWidth: 200, minHeight: 20 }}
        onClick={() => {
          onStartEdit(index);
        }}
        onFocus={() => {
          onStartEdit(index);
        }}
        tabIndex={isEditing ? "-1" : "0"}
      >
        {isEditing ? (
          <TextField
            autoFocus
            onMouseDown={(e) => {
              e.stopPropagation();
            }}
            value={options[index]}
            onChange={(e) => onEdit(e.target.value, index)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onStopEdit();
                onEnterKeyPress(index);
                e.preventDefault();
                e.stopPropagation();
              }
            }}
          />
        ) : (
          options[index]
        )}
      </ListItemText>
      <IconButton
        onClick={() => {
          onDelete(index);
        }}
        tabIndex="-1"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </StyledOptionRow>
  );
}

const StyledOptionRow = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    background-color: #e9e9e954;
  }
`;
const StyledFormControl=styled(FormControl)`
&&{
 padding-top:5px;
 padding-left:4px;
}
`;
export default DropDownColumnConfig;
